export default {
  getList: (params) => ['webhook-registration', 'list', params],
  getDetail: (id) => ['webhook-registration', 'detail', id],
  getFailedCallbacks: (id, params) => ['webhook-registration', 'failed-callbacks', id, params],
};
